import React, { useEffect, useState } from "react";
import "./SectionResultats.css";
import { fetchMatchResults } from "../../ServiceApi";
import MatchCard from "../MatchCard/MatchCard"; // Import du composant MatchCard

const SectionResultats = () => {
    const [matchResults, setMatchResults] = useState([]);
    const [selectedMatch, setSelectedMatch] = useState(null);

    useEffect(() => {
        const fetchResults = async () => {
            const clubId = 137104; // ID du club
            const today = new Date();
            const endDate = today.toISOString().split("T")[0];
            const startDate = new Date(today.setDate(today.getDate() - 7))
                .toISOString()
                .split("T")[0];

            const results = await fetchMatchResults(clubId, startDate, endDate);
            setMatchResults(
                results.filter(
                    (match) =>
                        match.home_score !== null && match.away_score !== null
                )
            );
        };

        fetchResults();
    }, []);

    if (matchResults.length === 0) {
        return (
            <div className="no-results">
                Aucun résultat trouvé pour cette semaine.
            </div>
        );
    }

    const handleMatchClick = (match) => {
        setSelectedMatch(match);
    };

    const closeModal = () => {
        setSelectedMatch(null);
    };

    return (
        <div className="results-section">
            <h2>Derniers Résultats des Équipes</h2>
            <div className="results-table">
                {matchResults.map((match, index) => (
                    <MatchCard
                        key={index}
                        match={match}
                        onClick={handleMatchClick} // Passez la fonction de clic
                    />
                ))}
            </div>

            {/*{selectedMatch && (
                <ModalResultat
                    match={selectedMatch}
                    onClose={closeModal}
                />
            )}*/}
        </div>
    );
};

export default SectionResultats;
